/**
 * Created by zhaoy on 2020/7/29
 * Desc: 持卡人搜索
 */

import React, {Component} from 'react'
import PhonesBean from 'model/PhonesBean'
import {getIntValue, getStrValue, isObjEmpty} from "../../utils/common";
import {Toast, SearchBar} from "antd-mobile";
import {_baseURL, API} from "../../configs/api.config";
import {fetchGet, fetchPost} from "../../utils/fetchRequest";
import {connect} from 'react-redux'
import CardLoseItem from "../../components/CardLoseItem";
import RosterBean from "../../model/RosterBean";

const mPageSize = 10
let mPageIndex = 0
let mSearchKey = ''

class CardSearch extends Component {

    constructor() {
        super()

        this.state = {
            isRefreshing: false,
            cardList: [],
            isLoading: false,
            searchKey: '',
            searchText: '',
        }
    }

    componentWillMount() {
        this.mType = this.props.match.params.type
        this.clazzId = this.props.match.params.clazzId
        if (this.mType === 'teacher') {
            this.title = '搜索学生'
        } else if (this.mType === 'parent') {
            this.title = '搜索学生'
        }
    }

    componentDidMount() {
        this.searchInput.focus()

        document.title = this.title
    }

    componentWillUnmount() {

    }

    render() {
        const {
            cardList, searchText
        } = this.state;
        let albumItems = []
        if (!isObjEmpty(cardList)) {
            for (let i = 0; i < cardList.length; i++) {
                const albumBean = cardList[i]
                if (!isObjEmpty(albumBean)) {
                    albumItems.push(
                        <CardLoseItem
                            albumBean={albumBean}
                            itemClick={this.onRosterItemClick.bind(this)}
                            index={i}
                            key={albumBean.stuId}/>
                    )
                }
            }
        }
        return (
            <div className='phone-select-root' style={{height: '100%'}}>
                <SearchBar placeholder={this.title} maxLength={20}
                           ref={ref => this.searchInput = ref}
                           value={searchText} onSubmit={this.searchSubmit}
                           onChange={this.searchChange} onClear={this.searchClear}
                           onCancel={this.searchCancel}/>
                <div className="header_days_sty">
                    <div className={'each_day_default'}>
                        姓名
                    </div>
                    <div className={'each_day_default'}>
                        卡状态
                    </div>
                    <div className={'each_day_default'}>
                        操作
                    </div>
                </div>
                {albumItems}
            </div>
        )
    }
    onRosterItemClick = (index) => {}

    searchChange = (value) => {
        mSearchKey = value
        this.setState({
            searchText: value
        })
    }


    searchClear = (e) => {
        if (!isObjEmpty(this.state.searchKey)) {
            mPageIndex = 0
            this.setState({
                isLoading: true,
                isRefreshing: false,
                searchText: '',
                searchKey: ''
            }, () => {
                this.loadPhones()
            })
        }
    }

    searchCancel = (e) => {
        console.log(e)
    }

    searchSubmit = (value) => {
        mPageIndex = 0
        this.setState({
            isLoading: true,
            isRefreshing: false,
            searchKey: value.trim()
        }, () => {
            this.loadPhones()
        })
    }

    loadPhones = () => {
        try {
            this.setState({
                isRefreshing: true
            })
        } catch (e) {
        }

        if (this.mType !== '') {
            this.url = API.SCHOOL_CARD_LIST
            this.params = {
                clazzId: this.clazzId,
            }
            this.getPhones()
        } else {
            Toast.hide()
            this.setState({
                isRefreshing: false
            })
        }
    }

    getPhones = () => {
        mPageIndex++
        console.log(mPageIndex)

        const {cardList, searchKey} = this.state
        if (mPageIndex === 1) {
            cardList.length = 0
        }

        fetchPost(this.url, {
            pageIndex: mPageIndex,
            pageSize: mPageSize,
            selectKey: searchKey,
            schoolId: this.props.userInfo.user.schoolId,
            ...this.params
        }).then(response => {
            Toast.hide();

            if (response && response.data) {
                if (this.mType == 'teacher') {
                    response.data.forEach((item, index) => {
                        let albumBean = new RosterBean()
                        albumBean.stuId = getIntValue(item, 'stuId')
                        albumBean.stuName = getStrValue(item, 'stuName')
                        albumBean.changType = getStrValue(item, 'changType')===1 && item.stuTeacherCard !==null && (getIntValue(item, 'stuTeacherCard')===1 || getIntValue(item, 'stuTeacherCard')===0)?"挂失中":
                            getStrValue(item, 'changType')===1?'正常': getStrValue(item, 'changType')===0?'已挂失':'无卡'

                        cardList.push(albumBean)
                    })
                } else if (this.mType == 'parent') {
                    let studentList = []
                    response.data.forEach((item, index) => {
                        if (item.studentDOS) {
                            studentList = studentList.concat(item.studentDOS)
                        }
                    })

                    if (!isObjEmpty(studentList)) {
                        studentList.forEach((item, index) => {
                            let phoneBean = new PhonesBean()
                            let phones = []
                            phoneBean.icon = require('imgs/ic_head' + (index % 15 + 1) + '.png')
                            phoneBean.icon = getStrValue(item, 'stuPhoto')
                            phoneBean.name = getStrValue(item, 'stuName')
                            phoneBean.claName = this.title

                            if (item.parentsDOS && item.parentsDOS.length > 0) {
                                item.parentsDOS.forEach((ite, ind) => {
                                    phoneBean.children.push(getStrValue(ite, 'parentsName'))
                                    phones.push(getStrValue(ite, 'userPhone'))
                                })
                            }

                            // if (phones.length > 0) {
                            phoneBean.phone = phones
                            // }

                            cardList.push(phoneBean)
                        })
                    }

                }
            } else {
                if (mPageIndex > 1) {
                    mPageIndex--
                }
            }

            this.setState({
                cardList,
                isLoading: false,
                isRefreshing: false,
            })
        }).catch(error => {
            Toast.hide()

            if (mPageIndex > 1) {
                mPageIndex--
            }
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常')
            }

            this.setState({
                isLoading: false,
                isRefreshing: false,
            })
        })
    }
}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo},
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(CardSearch)
